"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var videoplayer_device_1 = require("@svt/videoplayer-device");

var React = __importStar(require("react"));

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var PlayerState_1 = __importDefault(require("../constants/PlayerState"));

var videoplayer_device_2 = require("@svt/videoplayer-device");

var getKeyFromKeyboardEvent_1 = require("../utils/getKeyFromKeyboardEvent");

var seekToPercentage_1 = __importDefault(require("../utils/seekToPercentage"));

var VOLUME_STEP = 0.1;
var keyHandlers = {
  m: function m(_a, key) {
    var controller = _a.controller,
        muted = _a.muted;
    return muted ? controller.unMute() : controller.mute();
  },
  ' ': function _(_a, key) {
    var controller = _a.controller,
        playerState = _a.playerState;
    return playerState !== PlayerState_1["default"].PLAYING ? controller.play() : controller.pause();
  },
  arrowup: function arrowup(_a, key) {
    var controller = _a.controller,
        volume = _a.volume;
    return controller.setVolume(Math.min(volume + VOLUME_STEP, 1));
  },
  arrowdown: function arrowdown(_a, key) {
    var controller = _a.controller,
        volume = _a.volume;
    return controller.setVolume(Math.max(volume - VOLUME_STEP, 0));
  },
  f: function f(_a, key) {
    var getFullscreenElement = _a.getFullscreenElement;
    return videoplayer_device_2.toggleFullscreen(getFullscreenElement());
  },
  home: function home(_a) {
    var controller = _a.controller;
    return controller.seekTo(0);
  },
  end: function end(_a) {
    var controller = _a.controller,
        duration = _a.duration;
    return controller.seekTo(duration);
  },
  // Numbers
  number: function number(_a, key) {
    var controller = _a.controller,
        duration = _a.duration;
    seekToPercentage_1["default"](parseInt(key, 10) * 10, controller, duration);
  },
  mediapause: function mediapause(_a) {
    var controller = _a.controller;
    return controller.pause();
  },
  mediaplay: function mediaplay(_a) {
    var controller = _a.controller;
    return controller.play();
  },
  // Alias
  mediaplaypause: function mediaplaypause(props, key) {
    return keyHandlers[' '](props, key);
  },
  k: function k(props, key) {
    return keyHandlers[' '](props, key);
  }
};

var getKeyHandler = function getKeyHandler(key) {
  if (key.match(/^\d+$/)) {
    return keyHandlers.number;
  }

  return keyHandlers[key];
};

var SeekOperation;

(function (SeekOperation) {
  SeekOperation["FORWARD_ACTIVE"] = "forward_active";
  SeekOperation["FORWARD_STOP"] = "forward_stop";
  SeekOperation["BACKWARD_ACTIVE"] = "backward_active";
  SeekOperation["BACKWARD_STOP"] = "backward_stop";
})(SeekOperation = exports.SeekOperation || (exports.SeekOperation = {}));

exports.TIMER_SCHEDULER = 60;

exports.getMinMaxPosition = function (duration, position) {
  return Math.max(Math.min(position, duration), 0);
};

var createSeekObservable = function createSeekObservable(keyUp$, keyDown$) {
  return rxjs_1.merge(keyDown$.pipe(operators_1.filter(function (key) {
    return key === 'arrowright' || key === 'l';
  }), operators_1.mapTo(SeekOperation.FORWARD_ACTIVE)), keyUp$.pipe(operators_1.filter(function (key) {
    return key === 'arrowright' || key === 'l';
  }), operators_1.mapTo(SeekOperation.FORWARD_STOP)), keyDown$.pipe(operators_1.filter(function (key) {
    return key === 'arrowleft' || key === 'j';
  }), operators_1.mapTo(SeekOperation.BACKWARD_ACTIVE)), keyUp$.pipe(operators_1.filter(function (key) {
    return key === 'arrowleft' || key === 'j';
  }), operators_1.mapTo(SeekOperation.BACKWARD_STOP)));
};
/**
 * spacebar:           play/pause
 * k:                  play/pause
 * key up/down:        increase/decrease volume by 10 percent
 * arrow left/right:   seek 10 seconds
 * j/l                 seek 10 seconds
 * f:                  toggle fullscreen
 * m:                  mute/un-mute
 *
 * Not yet implemented:
 * c:                  captions on/off
 */


var Shortcuts =
/** @class */
function (_super) {
  __extends(Shortcuts, _super);

  function Shortcuts(props) {
    var _this = _super.call(this, props) || this;

    _this._onKeyDown = function (e) {
      var key = getKeyFromKeyboardEvent_1.getKeyFromKeyboardEvent(e.nativeEvent).toLowerCase();

      if (key in keyHandlers || key.includes('arrow')) {
        e.preventDefault();
      }

      _this.keyDown$.next(key);
    };

    _this._onKeyUp = function (e) {
      var key = getKeyFromKeyboardEvent_1.getKeyFromKeyboardEvent(e.nativeEvent).toLowerCase();

      _this.keyUp$.next(key);
    };

    _this.keyDown$ = new rxjs_1.Subject();
    _this.keyUp$ = new rxjs_1.Subject();
    _this.subscriptions = [];
    _this._handleKey = _this._handleKey.bind(_this);
    return _this;
  }

  Shortcuts.prototype.componentDidMount = function () {
    var _this = this;

    if (videoplayer_device_1.isHbbTV(window)) {
      var windowKeyUp$ = rxjs_1.fromEvent(window, 'keyup').pipe(operators_1.map(function (ev) {
        return getKeyFromKeyboardEvent_1.getKeyFromKeyboardEvent(ev).toLowerCase();
      }));
      var windowKeyDown$ = rxjs_1.fromEvent(window, 'keydown').pipe(operators_1.map(function (ev) {
        return getKeyFromKeyboardEvent_1.getKeyFromKeyboardEvent(ev).toLowerCase();
      }));
      this.subscriptions.push(windowKeyUp$.subscribe(function (key) {
        return _this.keyUp$.next(key);
      }));
      this.subscriptions.push(windowKeyDown$.subscribe(function (key) {
        return _this.keyDown$.next(key);
      }));
    }

    var keyMapHandler$ = this.keyUp$.pipe(operators_1.tap(this._handleKey));
    var seek$ = createSeekObservable(this.keyUp$, this.keyDown$).pipe(operators_1.distinctUntilChanged(), operators_1.switchMap(function (operation) {
      if (operation === SeekOperation.BACKWARD_STOP || operation === SeekOperation.FORWARD_STOP) {
        return rxjs_1.EMPTY.pipe(operators_1.startWith(0));
      }

      return rxjs_1.timer(0, exports.TIMER_SCHEDULER).pipe(operators_1.map(function (value) {
        return (value + 1) * exports.TIMER_SCHEDULER * (operation === SeekOperation.BACKWARD_ACTIVE ? -1 : 1);
      }));
    }), operators_1.map(function (time) {
      // This indicates keyup
      if (time === 0) {
        try {
          if (_this.props.uiPosition !== null) {
            if (_this.props.controller) {
              _this.props.controller.seekTo(_this.props.uiPosition);
            }

            _this.props.setState({
              uiPosition: null
            });
          }
        } catch (e) {
          _this.setState(function () {
            throw e;
          });
        }

        return;
      }

      var uiPosition = _this.props.uiPosition;
      var playerPosition = _this.props.position;

      if (uiPosition !== undefined && uiPosition !== null) {
        var maxTime = time < 0 ? Math.max(time, -3000) : Math.min(time, 3000);
        var t = Math.abs(maxTime) / 3000;
        var factor = Math.abs(t * (2 - t) * 0.01);
        return uiPosition + factor * maxTime;
      }

      return playerPosition + (time < 0 ? -10 : 10);
    }), operators_1.tap(function (uiPosition) {
      if (uiPosition !== undefined) {
        _this.props.setState({
          uiPosition: exports.getMinMaxPosition(_this.props.duration, uiPosition)
        });
      }
    }));
    this.subscriptions.push(rxjs_1.merge(keyMapHandler$, seek$).subscribe());
  };

  Shortcuts.prototype.componentWillUnmount = function () {
    this.subscriptions.forEach(function (subscription) {
      return subscription.unsubscribe();
    });
  };

  Shortcuts.prototype.render = function () {
    return this.props.children({
      onKeyDown: this._onKeyDown,
      onKeyUp: this._onKeyUp,
      className: this.props.className,
      style: this.props.style
    });
  };

  Shortcuts.prototype._handleKey = function (key) {
    var keyHandler = getKeyHandler(key);

    if (keyHandler) {
      if (this.props.controller !== null) {
        keyHandler(this.props, key);
      }

      return true;
    }

    return false;
  };

  return Shortcuts;
}(React.Component);

exports.Shortcuts = Shortcuts;
exports["default"] = Shortcuts;